import React from 'react';
import {Nav,NavItem} from 'react-bootstrap';
import Noimg from './../_img/no-img.jpg'

import _Data1 from './_data1';
import _Data2 from './_data2';
import _Data3 from './_data3';
import _Data4 from './_data4';
import _Data5 from './_data5';
import _Data6 from './_data6';

require( './Savecreditor.css');
export default class Savecustomer extends React.Component {
    state ={
        navACKey : "0",
        showResults : 0,
        device_photos : [],
    }

    handleSelect=(eventKey) =>{
        this.setState({navACKey:eventKey,showResults:eventKey});
        if(this.state.eventKey === 0 ){
            this.setState({isHidden: true});
        }else{
            this.setState({isHidden: false});
        }
    }
    
    componentDidMount(){
        setTimeout(() => {
            this.handleSelect("0");
        }, 500);
    }

    _handleImageChange(e) {
        if(e.target.value.length>0){
            e.preventDefault();
            let reader = new FileReader();
            let file = e.target.files[0];
            reader.onloadend = () => {
                this.setState({
                file: file,
                imagePreviewUrl: reader.result
                });
            }
            reader.readAsDataURL(file)
        }
    }

    render() {
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl}  height="100%" width="100%"/>);
        } else {
            $imagePreview = (<img src={Noimg}    height="100%" width="100%"/>);
        }
        return (
            <div>
                <nav class="navbar navbar-dark bg-primary">
                    <div class="flex-list">
                        <ul class="nav navbar-nav">
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-floppy-disk"> บันทึก</button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-file"> ใหม่ </button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-trash"> ลบ </button></li>
                            <span className="pipe"></span>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-print"> พิมพ์</button></li>
                            <li><button type="button" class="btn btn-xs glyphicon glyphicon-log-out" onClick={()=>{window.location.href = 'home'}}></button></li>
                        </ul>
                        <ul class="nav navbar-nav navbar-right" style={{'margin-right':'0px'}}>
                            <li>บันทึกข้อมูลเจ้าหนี้</li>
                            <span className="pipe"></span>
                        </ul>
                    </div>
                </nav>
                <div class="container topDiv">
                    <div class="div1">
                        <div class='row cs-order-book'>
                            <div class='col-sm-6 '>  
                                <div class="input-group group-custom">
                                    <span class="input-group-addon"> รหัสเจ้าหนี้ : </span>
                                    <input id="id1" type="text" class="form-control input-custom" name=""  />
                                    <span class="input-group-addon textIcon"> <i class="fas fa-search"></i> </span> 
                                </div>
                            </div>
                            <div class='col-sm-6 '>  
                                <div class="input-group group-custom">
                                    <span class="input-group-addon"> รหัสเก่า : </span>
                                    <input id="id1" type="text" class="form-control input-custom" name=""  />
                                 </div>
                            </div>     
                        </div>

                        <div class='row cs-order-book'>
                            <div class='col-sm-12 '>  
                                <div class="input-group group-custom-remark2">
                                    <span class="input-group-addon"> ชื่อเจ้าหนี้ : </span>
                                    <input   id="id1" type="text" class="form-control input-custom" name="F_Note"  onChange=""/>
                                </div>
                            </div>
                        </div>

                        <div class='row cs-order-book'>
                            <div class='col-sm-12 '>  
                                <div class="input-group group-custom-remark2">
                                    <span class="input-group-addon"> ที่อยู่ : </span>
                                    <textarea style={{resize:'none'}}  id="id1" type="text" class="form-control input-custom" name="F_Note"  onChange=""/>
                                </div>
                            </div>
                        </div>
                        
                        <div class='row cs-order-book'>
                            <div class='col-sm-6 '>  
                                <div class="input-group group-custom">
                                    <span class="input-group-addon"> โทรศัพท์ : </span>
                                    <input id="id1" type="text" class="form-control input-custom" name=""  />
                                </div>
                            </div>
                            <div class='col-sm-6 '>  
                                <div class="input-group group-custom">
                                    <span class="input-group-addon"> โทรสาร : </span>
                                    <input id="id1" type="text" class="form-control input-custom" name=""  />
                                 </div>
                            </div>     
                        </div>
                    </div>
                    <div class="div2">
                        <div class="userImg">
                            {$imagePreview}
                        </div>
                        <input type="file" onChange={(e)=>this._handleImageChange(e)} style={{display:"none"}} ref={fileInput => this.fileInput=fileInput}/>
                        <button class="BtnImg" onClick={() =>this.fileInput.click()}>เลือกรูปภาพ</button>
                    </div>
                </div>
                <Nav  bsStyle="tabs" activeKey={this.state.navACKey} onSelect={k => this.handleSelect(k)}>
                    <NavItem eventKey="0" >ข้อมูล1</NavItem>
                    <NavItem eventKey="1" >ข้อมูล2</NavItem>
                    <NavItem eventKey="2" >บัญชี</NavItem>
                    <NavItem eventKey="3" >ผู้ติดต่อ</NavItem>
                    <NavItem eventKey="4" >สถานที่ส่ง</NavItem>
                    <NavItem eventKey="5" >สินค้า</NavItem>
                </Nav>
                <div class="container divData" >
                    <_Data1 CustomerData={this.state}/>
                    <_Data2 CustomerData={this.state}/>
                    <_Data3 CustomerData={this.state}/>
                    <_Data4 CustomerData={this.state}/>
                    <_Data5 CustomerData={this.state}/>
                    <_Data6 CustomerData={this.state}/>
                </div>
            </div>
        )
    }
}